import { render, staticRenderFns } from "./physicalAward.vue?vue&type=template&id=f92ae464&scoped=true"
import script from "./physicalAward.vue?vue&type=script&lang=js"
export * from "./physicalAward.vue?vue&type=script&lang=js"
import style0 from "./physicalAward.vue?vue&type=style&index=0&id=f92ae464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92ae464",
  null
  
)

export default component.exports